import React, { useState, useEffect } from 'react';
import { trackNavCTAClick, trackNavSectionClick, trackDashboardLinkClick, trackMobileMenuToggle } from '../utils/analytics';

export default function Nav() {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector('.nav');
      if (nav) {
        nav.style.borderBottomColor = window.scrollY > 60 ? 'var(--grid-bright)' : 'var(--grid)';
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMobileOpen(false);
  };

  return (
    <nav className="nav">
      <a href="#hero" className="nav-logo" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}>
        <img src={process.env.PUBLIC_URL + '/logo.svg'} alt="Oscilabs" />
        <div className="nav-logo-text">OSCILABS<span>VISION</span></div>
      </a>
      <ul className="nav-links" style={mobileOpen ? { display: 'flex', flexDirection: 'column', position: 'absolute', top: 64, right: 0, background: 'rgba(4,8,16,0.95)', padding: '20px 40px', gap: 20, borderRadius: '0 0 0 12px' } : undefined}>
        <li><a href="#how-it-works" onClick={(e) => { e.preventDefault(); trackNavSectionClick('how_it_works'); scrollTo('how-it-works'); }}>How It Works</a></li>
        <li><a href="#solutions" onClick={(e) => { e.preventDefault(); trackNavSectionClick('solutions'); scrollTo('solutions'); }}>Solutions</a></li>
        <li><a href="https://site.charitysense.com" target="_blank" rel="noopener noreferrer" onClick={trackDashboardLinkClick}>Live Dashboard</a></li>
        <li><a href="#faq" onClick={(e) => { e.preventDefault(); trackNavSectionClick('faq'); scrollTo('faq'); }}>FAQ</a></li>
        <li><a href="#contact" className="nav-cta" onClick={(e) => { e.preventDefault(); trackNavCTAClick(); scrollTo('contact'); }}>Get Started</a></li>
      </ul>
      <button className="mobile-menu-btn" onClick={() => { trackMobileMenuToggle(!mobileOpen); setMobileOpen(!mobileOpen); }}>&#9776;</button>
    </nav>
  );
}
